import React from 'react';
import { Feature } from '@tencent/workbench';
import BaseToolbarFeature from '@src/framework/workbench/common/feature/base-toolbar-feature';
import type { IAnimDelayFeature } from './anim-delay-interface';
import { config } from './config';
import AnimSelector from '@src/framework/frame-pc/components/anim-selector';
import { PPTEditorStateEnumType } from '@src/slide/domain/ui-model/constant/edit-state-type';


@Feature()
export class AnimDelayFeature extends BaseToolbarFeature implements IAnimDelayFeature {
    public id = config.id;
    public config = config;
    private selectedAnimList = this.getSelectedAnimManager()?.selectedArray;
    public constructor() {
        super();
    }

    public getDropdownContent() {
        return (
            <AnimSelector
                selectionService={this.getSelectionService()}
                selectedAnimList={this.getSelectedAnimManager()?.selectedArray}
                type="delay"
            />
        );
    }

    public shouldDisabled(): boolean {
        if (this.getUserPriviledgeService().pptEditorState !== PPTEditorStateEnumType.EDITABLE) return true;
        return !this.selectedAnimList?.length;
    }
}
